export default function Home() {
  return <h1>🏠 sales Page</h1>;
}